import React from "react";
import { FormType } from "@/hooks/auth/types";
import { ImageWithFallback } from "./ImageWithFallback";
import logo from "/lovable-uploads/5639bd1d-d899-4190-af54-f5f73944d997.png";

interface ModernAuthCardProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
  formType: FormType;
  onSwitchForm: (type: FormType) => void;
}

export const ModernAuthCard: React.FC<ModernAuthCardProps> = ({
  children,
  title,
  subtitle,
  formType,
  onSwitchForm,
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0f141c] relative overflow-hidden w-full">
      {/* Ambient background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#00B6F0]/20 via-[#00B6F0]/5 to-transparent opacity-50" />
      
      {/* Centered glass card */}
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-gradient-to-r from-[#ffffff08] to-[#0f141c] backdrop-blur-sm border border-[#ffffff10] shadow-2xl p-8 flex flex-col items-center mx-4">
        {/* Logo */}
        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-[#00B6F0]/20 mb-6 shadow-lg overflow-hidden">
          <ImageWithFallback 
            src={logo} 
            alt="Arena Pro Player Logo" 
            className="w-12 h-12 object-contain"
            fallbackSrc="https://placehold.co/48x48/252B36/00B6F0?text=A"
          />
        </div>
        
        {/* Title */}
        <h2 className="text-2xl font-semibold text-[#00B6F0] mb-2 text-center">
          {title}
        </h2>
        
        {/* Subtitle */}
        <p className="text-white/60 text-sm mb-6 text-center">
          {subtitle}
        </p>
        
        {/* Form Type Selector */}
        <div className="flex justify-center gap-4 mb-6 w-full">
          <button
            onClick={() => onSwitchForm("login")}
            className={`px-4 py-2 text-sm rounded-lg transition-all ${
              formType === "login" 
                ? "bg-[#00B6F0] text-white shadow-lg shadow-[#00B6F0]/20" 
                : "text-white/60 hover:text-white/80"
            }`}
          >
            Entrar
          </button>
          
          <button
            onClick={() => onSwitchForm("signup")}
            className={`px-4 py-2 text-sm rounded-lg transition-all ${
              formType === "signup" 
                ? "bg-[#00B6F0] text-white shadow-lg shadow-[#00B6F0]/20" 
                : "text-white/60 hover:text-white/80"
            }`}
          >
            Cadastrar
          </button>
          
          <button
            onClick={() => onSwitchForm("reset")}
            className={`px-4 py-2 text-sm rounded-lg transition-all ${
              formType === "reset" 
                ? "bg-[#00B6F0] text-white shadow-lg shadow-[#00B6F0]/20" 
                : "text-white/60 hover:text-white/80"
            }`}
          >
            Recuperar
          </button>
        </div>
        
        {/* Form Content */}
        <div className="w-full">
          {children}
        </div>
      </div>
      
      {/* Bottom text */}
      <div className="relative z-10 mt-8 flex flex-col items-center text-center mx-4">
        <p className="text-gray-400 text-sm mb-2">
          Arena - <span className="font-medium text-white">Plataforma de mentorias para gamers</span>
        </p>
      </div>
    </div>
  );
};
